import { render, staticRenderFns } from "./AssinaturaDigital.vue?vue&type=template&id=2f81adc8"
import script from "./AssinaturaDigital.vue?vue&type=script&lang=js"
export * from "./AssinaturaDigital.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports